import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/leemerh/Header";
import { Hero } from "@/components/leemerh/Hero";
import { About } from "@/components/leemerh/About";
import { Services } from "@/components/leemerh/Services";
import { Process } from "@/components/leemerh/Process";
import { Gallery } from "@/components/leemerh/Gallery";
import { Testimonials } from "@/components/leemerh/Testimonials";
import { Faq } from "@/components/leemerh/Faq";
import { Instagram } from "@/components/leemerh/Instagram";
import { Contact } from "@/components/leemerh/Contact";
import { Footer } from "@/components/leemerh/Footer";
import { Admin } from "@/components/leemerh/Admin";

const Home = () => (
    <>
        <Header />
        <main>
            <Hero />
            <About />
            <Services />
            <Process />
            <Gallery />
            <Testimonials />
            <Faq />
            <Instagram />
            <Contact />
        </main>
        <Footer />
    </>
);

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#0E3B2E",
                        border: "1px solid rgba(201,162,39,0.5)",
                        color: "#FBF8F2",
                        fontFamily: "Montserrat, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
